<div class="btn-toolbar justify-content-center justify-content-md-end">
  <button type="button" class="btn btn-primary" (click)="cancelEvent.emit()">
    {{ "buttons." + cancelButtonText | msg | async }}
  </button>
  <button
    type="button"
    class="btn btn-danger ms-3"
    (click)="submitEvent.emit()"
    [disabled]="isLoading"
  >
    <span *ngIf="!isLoading">
      {{ "buttons." + submitButtonText | msg | async }}</span
    >
    <div *ngIf="isLoading" class="d-flex justify-content-center">
      <div class="spinner-border custom-spinner" role="status"></div>
    </div>
  </button>
</div>
